import React from "react";

const EmailView = ({ email }) => {

  if (!email) return null;

  return (
    <div className="p-4 bg-white">

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>{email.name}</h5>
        <span>{email.time}</span>
      </div>

      <p><b>Subject:</b> {email.subject}</p>

      <hr/>

      <p>Dear Angela,</p>

      <p>
      I am writing to request a meeting to discuss the progress and next steps
      for Project. We have reached a critical milestone, and I believe a
      discussion will help align our efforts and ensure we are on track to meet
      our goals.
      </p>

      <p>
      Looking forward to your response.
      </p>

      <p>Best regards,<br/>Arman</p>

      <hr/>

      <h6>Attachments</h6>

      <div className="d-flex">

        <img src="/assets/img/media/media-01.jpg" width="80" className="me-2"/>
        <img src="/assets/img/media/media-02.jpg" width="80" className="me-2"/>
        <img src="/assets/img/media/media-03.jpg" width="80"/>

      </div>

    </div>
  );
};

export default EmailView;